import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { CertificateIcon } from "../assets/icons";
import { categoryMap } from "../config/CategoryMap";
import { ROUTES, buildRoute } from "../routes/RouteNames";
import makeSlug from "../utils/makeSlug";
import "./Path.css";

const Path = ({
    mode,           // "tech" | "workers" | "favourites"
    category,       // slug kategorie
    userName,       // jméno uživatele
    userId,         // ID uživatele
    customLabel,    // "Moje nabídky" atd.
    name,           // název detailu položky
    isVerified      // zda je uživatel ověřen
}) => {

    // Pomocná funkce pro text vs odkaz
    const BreadcrumbItem = ({ to, label, isLast, badge }) => (
        <>
            <p className="path-right_arrow">&rsaquo;</p>
            <p>
                {isLast ? (
                    <span className="path-a active-path">
                        {label.toUpperCase()}
                        {badge}
                    </span>
                ) : (
                    <Link className="path-a" to={to}>
                        {label.toUpperCase()}
                        {badge}
                    </Link>
                )}
            </p>
        </>
    );

    return (
        <div className="all-path">
            <div className="path">
                {/* 0. HOME */}
                <p className="home">
                    <Link className="path-a" to="/app">
                        <FontAwesomeIcon icon={faHouse} />
                    </Link>
                </p>

                {/* 1. HLAVNÍ SEKCE */}
                {mode && (
                    <BreadcrumbItem
                        to={mode === "tech" ? ROUTES.TECH : mode === "workers" ? ROUTES.WORKERS : mode === "jobs" ? ROUTES.JOBS : ROUTES.FAVOURITES}
                        label={mode === "tech" ? "TECHNIKA" : mode === "workers" ? "PRACOVNÍCI" : mode === "jobs" ? "PRÁCE" : "ULOŽENÉ NABÍDKY"}
                        isLast={!category && !userName && !customLabel && !name}
                    />
                )}

                {/* 2. KATEGORIE */}
                {category && (
                    <BreadcrumbItem
                        to={buildRoute(mode === "tech" ? ROUTES.TECH_CATEGORY : mode === "jobs" ? ROUTES.JOBS_CATEGORY : ROUTES.WORKERS_CATEGORY, { subcategory: category })}
                        label={categoryMap[category] || category}
                        isLast={!userName && !customLabel && !name}
                    />
                )}

                {/* 3. UŽIVATEL / MOJE NABÍDKY */}
                {(userName || customLabel) && (
                    <BreadcrumbItem
                        to={customLabel === "Moje nabídky"
                            ? `/user/${userId}/listings`
                            : `/user/${userId}/${makeSlug(userName || "").replace(/_/g, "-")}`}
                        label={customLabel || userName}
                        badge={isVerified && <CertificateIcon className="certificate_icon--small" />}
                        isLast={!name}
                    />
                )}

                {/* 4. DETAIL POLOŽKY */}
                {name && (
                    <>
                        <p className="path-right_arrow">&rsaquo;</p>
                        <p><span className="path-a active-path">{name.toUpperCase()}</span></p>
                    </>
                )}
            </div>
        </div>
    );
};

export default Path;
